export const getEachWayTitle = (eachWayTranslation: string, placeTerms: number, oddsTerms: number): string => {
    //  $string('General').EachWay vs $string('General').EachWayTag
     if (placeTerms <= 0 || oddsTerms <= 0) { return "";}

        var pt = placeTerms;
        var eachWay = `${eachWayTranslation} 1/${oddsTerms}`;

        let options: number[] = []
        for (let i = 1; i <= pt; i++) {
            options.push(i);
        }

        return `- ${eachWay} ${options.join("-")}`;
}